import { createFileRoute, Link, notFound } from "@tanstack/react-router";
import { HeadToHead } from "@/components/runboom/head-to-head";
import { BrandFooter } from "@/components/runboom/marks";
import { runners } from "@/lib/mock";

export const Route = createFileRoute("/u/$handle/vs/$rival")({
  loader: ({ params }) => {
    const a = runners[params.handle];
    const b = runners[params.rival];
    if (!a || !b) throw notFound();
    if (a.handle === b.handle) throw notFound();
    return { a, b };
  },
  component: HeadToHeadPage,
});

function HeadToHeadPage() {
  const { a, b } = Route.useLoaderData();

  return (
    <main className="mx-auto max-w-[1280px] px-5 py-6 sm:px-6 sm:py-10">
      <nav className="flex items-center gap-3 border-b border-border pb-4 font-mono text-[11px] uppercase tracking-[0.12em] text-fg-muted">
        <Link to="/" className="hover:text-fg">RUNBOOM</Link>
        <span aria-hidden>/</span>
        <Link
          to="/u/$handle"
          params={{ handle: a.handle }}
          className="hover:text-fg"
        >
          @{a.handle}
        </Link>
        <span aria-hidden>/</span>
        <span className="text-fg">vs @{b.handle}</span>
      </nav>

      <section className="mt-6 sm:mt-8">
        <HeadToHead a={a} b={b} />
      </section>

      <BrandFooter />
    </main>
  );
}
